import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authForgotPasswordPath } from '#/modules/auth/routing/auth.paths';
import type { RoutePathLoaderArgs } from '#/routing/classes/types/RoutePathLoaderArgs';
import type { RouteProps } from '#/routing/types/RouteProps';

import { AuthForgotPasswordPage } from './AuthForgotPassword.page';

export async function loader(
  _: RoutePathLoaderArgs<typeof authForgotPasswordPath>,
) {
  // empty loader
}

export default function AuthForgotPasswordRoute(_: RouteProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={i18n('Reset Password')}
      linkRels={{ canonical: authForgotPasswordPath.with({}) }}
    >
      <AuthForgotPasswordPage />
    </RouteModule>
  );
}
